/**
 * スキル関連の定数
 * プログラミング言語・フレームワークのリスト
 */

/**
 * 一般的なプログラミング言語とフレームワークのリスト
 * エンジニア登録やスキル管理で使用
 */
export const commonSkills = [
  'JavaScript', 'TypeScript', 'React', 'Node.js', 'Python', 'Java', 'C#', 'PHP', 'Go',
  'Swift', 'Kotlin', 'Flutter', 'React Native', 'Vue.js', 'Angular', 'Next.js', 'Nuxt.js',
  'Express.js', 'Django', 'Flask', 'Spring Boot', 'Laravel', 'Ruby on Rails', 'ASP.NET',
  'MySQL', 'PostgreSQL', 'MongoDB', 'Redis', 'Elasticsearch', 'AWS', 'Azure', 'GCP',
  'Docker', 'Kubernetes', 'Git', 'CI/CD', 'Linux', 'Nginx', 'Apache'
];

// O(1) ルックアップ用の Set（js-set-map-lookups ルール適用）
const commonSkillsSet = new Set(
  commonSkills.map(skill => skill.toLowerCase())
);

/**
 * スキル名がプログラミング言語・フレームワークかどうかを判定する関数
 * @param skillName - 検証するスキル名
 * @returns 有効なスキルの場合はtrue
 */
export const isValidSkill = (skillName: string): boolean => {
  return commonSkillsSet.has(skillName.trim().toLowerCase());
};
